import React, { useContext, useEffect, useState } from 'react'
import EventContext from '../contexts/EventContext';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Layout from './Layout';
import RegistrationDashboardLayout from './RegistrationDashboardLayout';
import { GroupListSection } from './FormulaireList';
import { API_URL } from '../config';
import useGetFormulaireList from '../customHooks/UseGetFormulaireList';

const RegistrationDashbordLinks = ({ isAdmin, profile }) => {

    const { currentEvent } = useContext(EventContext);
    const { ownerIdContact } = useParams();
    const [eventFormulaireEventComposantList, setEventFormulaireEventComposantList] = useState(null);
    const [formulaireEventList, setFormulaireEventList] = useState(null);

    // Formulaires sélectionnés par composant pour cet événement (table event_formulaire_event_composant),
    // même source que la page manager_cc/events/event_composant
    const selectedFormulaireIds = [...new Set((eventFormulaireEventComposantList || [])
        .map(item => item.formulaire_event_composant?.formulaire?.id_formulaire)
        .filter(Boolean)
        .map(String))];

    const { formulaireList } = useGetFormulaireList({
        params: selectedFormulaireIds.length > 0
            ? ` WHERE id_formulaire IN (${selectedFormulaireIds.join(',')})`
            : null
    });

    const getEventFormulaireEventComposantList = async () => {
        await fetch(`${API_URL}?action=getEventFormulaireEventComposantList&filter= WHERE id_event=${currentEvent.id_event} `)
            .then(res => res.json())
            .then(res => setEventFormulaireEventComposantList(res))
    }

    const getFormulaireEventList = async () => {
        await fetch(`${API_URL}?action=getFormulaireEventList&params= WHERE id_event=${currentEvent.id_event}  `)
            .then(res => res.json())
            .then(res => setFormulaireEventList(res))
    }

    useEffect(() => {
        if (!currentEvent) return;

        getEventFormulaireEventComposantList();
        getFormulaireEventList();
    }, [currentEvent]);

    const isLoading = !currentEvent
        || eventFormulaireEventComposantList === null
        || (selectedFormulaireIds.length > 0 && !formulaireList);

    if (isLoading) {
        return (
            <Layout>
                <div className="p-8 text-gray-800 dark:text-white dark:bg-neutral-950 min-h-screen">
                    Chargement des formulaires...
                </div>
            </Layout>
        );
    }

    // Regroupement par composant événementiel : une catégorie par composant,
    // contenant uniquement les formulaires cochés dans le manager
    const cibleCategoryMap = {};

    eventFormulaireEventComposantList.forEach(item => {
        const formulaire = item.formulaire_event_composant?.formulaire;
        const eventComposant = item.formulaire_event_composant?.event_composant;

        if (!formulaire || !eventComposant) return;

        const key = eventComposant.id_event_composant;

        if (!cibleCategoryMap[key]) {
            cibleCategoryMap[key] = {
                cibleCategoryName: eventComposant.event_composant_nom,
                formulaireIds: []
            };
        }

        const idFormulaire = String(formulaire.id_formulaire);

        if (!cibleCategoryMap[key].formulaireIds.includes(idFormulaire)) {
            cibleCategoryMap[key].formulaireIds.push(idFormulaire);
        }
    });

    const cibleCategory = Object.values(cibleCategoryMap)
        .sort((a, b) => a.cibleCategoryName.localeCompare(b.cibleCategoryName));

    const groupData = [
        {
            groupName: "",
            cibleList: [{ cibleName: "", cibleCategory: cibleCategory }]
        }
    ]

    return (
        <RegistrationDashboardLayout
            isAdmin={isAdmin}
            profile={profile}>
            <div className="p-4 md:p-8 bg-gray-50 dark:bg-neutral-950 min-h-screen">
                <h2 className="text-xl md:text-2xl py-3 font-bold text-gray-800 dark:text-white">
                    Table des liens d'invitation pour votre portefolio
                </h2>
                {cibleCategory.length === 0 ? (
                    <p className="text-gray-500 dark:text-neutral-400">
                        Aucun formulaire n'a été sélectionné pour cet événement.
                    </p>
                ) : (
                    groupData.map(group => (
                        <GroupListSection
                            key={group.groupName}
                            groupName={group.groupName}
                            cibleList={group.cibleList}
                            currentEvent={currentEvent}
                            formulaireList={formulaireList}
                            ownerIdContact={ownerIdContact}
                            formulaireEventList={formulaireEventList}
                        />
                    ))
                )}
            </div>
        </RegistrationDashboardLayout>
    )
}

export default RegistrationDashbordLinks
